<template>
    <BaseTemplate app-name="Fila de Reconvocação" page-title="">
        <template #content>
            <div class="px-6 pt-6">
      <!-- Stats Cards -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">

      </div>

            <!-- Search and Filters -->
            <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md mb-6 border border-gray-200 dark:border-gray-700">
                <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo</label>
                        <select
                            v-model="filters.type"
                            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            :style="{ '--tw-ring-color': 'var(--clinic-btn-bg)' }"
                        >
                            <option value="">Todos</option>
                            <option value="pendencia">Pendência</option>
                            <option value="reconvocacao">Reconvocação</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Status</label>
                        <select
                            v-model="filters.status"
                            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            :style="{ '--tw-ring-color': 'var(--clinic-btn-bg)' }"
                        >
                            <option value="">Todos</option>
                            <option value="pending">Pendente</option>
                            <option value="scheduled">Agendado</option>
                            <option value="completed">Concluído</option>
                            <option value="cancelled">Cancelado</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data de Criação</label>
                        <input
                            v-model="filters.createdDate"
                            type="date"
                            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            :style="{ '--tw-ring-color': 'var(--clinic-btn-bg)' }"
                        />
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Buscar Paciente</label>
                        <input
                            v-model="filters.patientName"
                            type="text"
                            placeholder="Nome do paciente..."
                            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            :style="{ '--tw-ring-color': 'var(--clinic-btn-bg)' }"
                        />
                    </div>
                    <div class="flex items-end">
                        <button
                            @click="applyFilters"
                            class="w-full px-4 py-2 text-white rounded-md focus:outline-none focus:ring-2 transition-colors"
                            :style="{ backgroundColor: 'var(--clinic-btn-bg)', '--tw-ring-color': 'var(--clinic-btn-bg)' }"
                            @mouseenter="$event.target.style.backgroundColor = 'var(--clinic-btn-bg-hover)'"
                            @mouseleave="$event.target.style.backgroundColor = 'var(--clinic-btn-bg)'"
                        >
                            Filtrar
                        </button>
                    </div>
                </div>
                <div class="flex gap-2">
                    <button 
                        @click="clearFilters"
                        class="px-4 py-2 bg-gray-600 dark:bg-gray-700 text-white rounded-md hover:bg-gray-700 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
                    >
                        Limpar
                    </button>
                </div>
            </div>

            <!-- Queue List -->
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
                <div class="p-6 border-b border-gray-200 dark:border-gray-700">
                    <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
                        Fila de Ações Pendentes ({{ recallQueue.length }})
                    </h2>
                </div>
        
                <div v-if="isLoading" class="p-6 text-center">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 mx-auto" :style="{ borderColor: 'var(--clinic-btn-bg)' }"></div>
                    <p class="mt-2 text-gray-600 dark:text-gray-400">Carregando...</p>
                </div>

                <div v-else-if="recallQueue.length === 0" class="p-6 text-center">
                    <InboxIcon class="mx-auto h-12 w-12 text-gray-400" />
                    <h3 class="mt-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ recallQueue.length === 0 ? 'Fila vazia' : 'Nenhuma ação encontrada' }}
                    </h3>
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                        {{ recallQueue.length === 0 
                        ? 'A fila de ações pendentes está vazia. Use o botão "Solicitar Ação" nos laudos para adicionar itens.' 
                        : 'Não há ações pendentes com os filtros aplicados.' 
                        }}
                    </p>
                </div>

                <div v-else class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead class="bg-gray-50 dark:bg-gray-700">
                            <tr>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Tipo
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Paciente
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Exame Original
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Motivo
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Status
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Criado em
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                    Ações
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            <tr v-for="item in recallQueue" :key="item.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                                <!-- Tipo -->
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span :class="getTypeBadgeClass(item.type)" class="inline-flex px-3 py-1 text-xs font-semibold rounded-full">
                                        {{ getTypeText(item.type) }}
                                    </span>
                                </td>
                                <!-- Paciente -->
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="flex items-center">
                                        <div class="ml-4">
                                            <div class="text-sm font-medium text-gray-900 dark:text-gray-100">
                                                {{ item.patient_name }}
                                            </div>
                                            <div class="text-sm text-gray-500 dark:text-gray-400">
                                                {{ item.patient_document }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <!-- Exame Original -->
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900 dark:text-gray-100">{{ item.service_name }}</div>
                                    <div class="text-sm text-gray-500 dark:text-gray-400">
                                        OS: {{ item.accession_number }}
                                    </div>
                                    <div class="text-sm text-gray-400 dark:text-gray-500">
                                        {{ formatDate(item.original_date) }} às {{ item.original_time }}
                                    </div>
                                </td>
                                <!-- Motivo -->
                                <td class="px-6 py-4">
                                    <div class="max-w-xs">
                                        <div class="text-sm font-medium text-gray-900 dark:text-gray-100">
                                            {{ getReasonTypeText(item.reason_type) }}
                                        </div>
                                        <div class="text-sm text-gray-500 dark:text-gray-400 truncate" :title="item.description">
                                            {{ item.description }}
                                        </div>
                                        <div v-if="item.additional_notes" class="text-xs text-gray-400 dark:text-gray-500 truncate" :title="item.additional_notes">
                                            {{ item.additional_notes }}
                                        </div>
                                    </div>
                                </td>
                                <!-- Status -->
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span :class="getStatusBadgeClass(item.status)" class="inline-flex px-2 py-1 text-xs font-semibold rounded-full">
                                        {{ getStatusText(item.status) }}
                                    </span>
                                </td>
                                <!-- Criado em -->
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {{ formatDateTime(item.created_at) }}
                                </td>
                                <!-- Ações -->
                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                    <div class="flex space-x-2">
                                        <button
                                            v-if="item.status === 'pending'"
                                            @click="openScheduleModal(item)"
                                            class="px-3 py-1 rounded-md text-sm text-white transition-colors"
                                            :style="{ backgroundColor: 'var(--clinic-btn-bg)' }"
                                            @mouseenter="$event.target.style.backgroundColor = 'var(--clinic-btn-bg-hover)'"
                                            @mouseleave="$event.target.style.backgroundColor = 'var(--clinic-btn-bg)'"
                                        >
                                            Agendar
                                        </button>
                                        <button
                                            @click="viewDetails(item)"
                                            class="px-3 py-1 rounded-md text-sm text-white transition-colors"
                                            :style="{ backgroundColor: 'var(--clinic-btn-bg)' }"
                                            @mouseenter="$event.target.style.backgroundColor = 'var(--clinic-btn-bg-hover)'"
                                            @mouseleave="$event.target.style.backgroundColor = 'var(--clinic-btn-bg)'"
                                        >
                                            Detalhes
                                        </button>
                                        <button
                                            v-if="item.status === 'pending'"
                                            @click="cancelRecall(item)"
                                            class="px-3 py-1 rounded-md text-sm text-white transition-colors bg-red-600 hover:bg-red-700"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div v-if="recallQueue.length > 0" class="px-6 py-3 border-t border-gray-200 dark:border-gray-700">
            <div class="flex items-center justify-between">
                <div class="text-sm text-gray-700 dark:text-gray-300">
                    Mostrando {{ paginationStart + 1 }} a {{ paginationEnd }} de {{ totalItems }} resultados
                </div>
                <div class="flex space-x-2">
                    <button
                        @click="previousPage"
                        :disabled="currentPage === 1"
                        class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        Anterior
                    </button>
                    <span class="px-3 py-1 text-sm text-gray-700 dark:text-gray-300">
                        Página {{ currentPage }} de {{ totalPages }}
                    </span>
                    <button
                        @click="nextPage"
                        :disabled="currentPage === totalPages"
                        class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        Próxima
                    </button>
                </div>
            </div>
        </div>
      </div>
    </div>

    <!-- Schedule Modal -->
    <ScheduleRecallModal
      v-if="showScheduleModal"
      :recall-item="selectedRecallItem"
      @close="closeScheduleModal"
      @scheduled="onRecallScheduled"
    />

    <!-- Details Modal -->
    <RecallDetailsModal
      v-if="showDetailsModal"
      :recall-item="selectedRecallItem"
      @close="closeDetailsModal"
    />

</template>
  </BaseTemplate>
</template> 
<script>
import BaseTemplate from '../templates/BaseTemplate.vue'
import { ref, computed, onMounted } from 'vue'
import { 

  InboxIcon
} from '@heroicons/vue/24/outline'
import ScheduleRecallModal from './components/ScheduleRecallModal.vue'
import RecallDetailsModal from './components/RecallDetailsModal.vue'
import { recallQueueService } from '@/services/recallQueueService'
import { useClinicStore } from '../../stores/settings/clinicStore'


export default {
  name: 'RecallQueuePage',
  components: {
    BaseTemplate,


    InboxIcon,
    ScheduleRecallModal,
    RecallDetailsModal
  },
  setup() {
    const clinicStore = useClinicStore()
    const isLoading = ref(false)
    const recallQueue = ref([])
    const currentPage = ref(1)
    const itemsPerPage = ref(20)
    const showScheduleModal = ref(false)
    const showDetailsModal = ref(false)
    const selectedRecallItem = ref(null)
    const totalItems = ref(0)
    const totalPages = ref(0)

    const filters = ref({
      type: '',
      status: '',
      createdDate: '',
      patientName: ''
    })

    const stats = ref({
      pending: 0,
      scheduledToday: 0,
      completedToday: 0,
      cancelledToday: 0
    })

    // Computed properties
    const paginationStart = computed(() => {
      return (currentPage.value - 1) * itemsPerPage.value
    })
    
    const paginationEnd = computed(() => {
      return Math.min(paginationStart.value + itemsPerPage.value, totalItems.value)
    })

    // Methods
    const loadQueue = async () => {
      isLoading.value = true
      try {
        // Preparar parâmetros para o backend
        const params = {
          page: currentPage.value,
          limit: itemsPerPage.value,
          offset: paginationStart.value
        }
        
        // Adicionar filtros se existirem
        if (filters.value.type) {
          params.type = filters.value.type
        }
        if (filters.value.status) {
          params.status = filters.value.status
        }
        if (filters.value.createdDate) {
          params.created_date = filters.value.createdDate
        }
        if (filters.value.patientName) {
          params.patient_name = filters.value.patientName
        }
        
        const response = await recallQueueService.getQueue(params)
        
        // Verificar se a resposta tem a estrutura esperada
        if (response.data && response.data.items) {
          // Nova estrutura com paginação
          recallQueue.value = response.data.items
          totalItems.value = response.data.total
          totalPages.value = response.data.total_pages
        } else if (Array.isArray(response.data)) {
          // Estrutura antiga (fallback)
          recallQueue.value = response.data
          totalItems.value = response.data.length
          totalPages.value = Math.ceil(response.data.length / itemsPerPage.value)
        } else {
          console.warn('Estrutura de resposta inesperada:', response)
          recallQueue.value = []
          totalItems.value = 0
          totalPages.value = 0
        }
        
        console.log('Dados da fila carregados:', recallQueue.value.length, 'itens')
        console.log('Total de itens:', totalItems.value)
        console.log('Total de páginas:', totalPages.value)
        
        calculateStats()
      } catch (error) {
        console.error('Erro ao carregar fila de reconvocação:', error)
        recallQueue.value = []
        totalItems.value = 0
        totalPages.value = 0
      } finally {
        isLoading.value = false
      }
    }

    const calculateStats = () => {
      const today = new Date().toISOString().split('T')[0]
      
      stats.value = {
        pending: recallQueue.value.filter(item => item.status === 'pending').length,
        scheduledToday: recallQueue.value.filter(item => 
          item.status === 'scheduled' && 
          item.rescheduled_date === today
        ).length,
        completedToday: recallQueue.value.filter(item => 
          item.status === 'completed' && 
          item.completed_date === today
        ).length,
        cancelledToday: recallQueue.value.filter(item => 
          item.status === 'cancelled' && 
          item.cancelled_date === today
        ).length
      }
    }

    const refreshQueue = () => {
      loadQueue()
    }

    const applyFilters = () => {
      currentPage.value = 1
      loadQueue()
    }

    const clearFilters = () => {
      filters.value = {
        type: '',
        status: '',
        createdDate: '',
        patientName: ''
      }
      currentPage.value = 1
      loadQueue()
    }

    const previousPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--
        loadQueue()
      }
    }

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
        loadQueue()
      }
    }

    const openScheduleModal = (item) => {
      selectedRecallItem.value = item
      showScheduleModal.value = true
    }

    const closeScheduleModal = () => {
      showScheduleModal.value = false
      selectedRecallItem.value = null
    }

    const viewDetails = (item) => {
      selectedRecallItem.value = item
      showDetailsModal.value = true
    }

    const closeDetailsModal = () => {
      showDetailsModal.value = false
      selectedRecallItem.value = null
    }

    const onRecallScheduled = () => {
      closeScheduleModal()
      loadQueue()
    }

    const cancelRecall = async (item) => {
      if (!confirm('Tem certeza que deseja cancelar esta reconvocação?')) {
        return
      }

      try {
        await recallQueueService.cancelRecall(item.id)
        await loadQueue()
      } catch (error) {
        console.error('Erro ao cancelar reconvocação:', error)
      }
    }

    const formatDate = (date) => {
      if (!date) return ''
      return new Date(date).toLocaleDateString('pt-BR')
    }

    const formatDateTime = (datetime) => {
      if (!datetime) return ''
      return new Date(datetime).toLocaleString('pt-BR')
    }

    const getStatusText = (status) => {
      const statusMap = {
        pending: 'Pendente',
        scheduled: 'Agendado',
        completed: 'Concluído',
        cancelled: 'Cancelado'
      }
      return statusMap[status] || status
    }

    const getStatusBadgeClass = (status) => {
      const classMap = {
        pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
        scheduled: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
        completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
        cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
      }
      return classMap[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
    }

    const getTypeText = (type) => {
      const typeMap = {
        pendencia: 'Pendência',
        reconvocacao: 'Reconvocação'
      }
      return typeMap[type] || type
    }

    const getTypeBadgeClass = (type) => {
      const classMap = {
        pendencia: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
        reconvocacao: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
      }
      return classMap[type] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
    }

    const getReasonTypeText = (reasonType) => {
      const reasonMap = {
        // Motivos de Pendência
        'aguardando_documentos': 'Aguardando Documentos',
        'aguardando_autorizacao': 'Aguardando Autorização',
        'aguardando_pagamento': 'Aguardando Pagamento',
        'aguardando_laudo_anterior': 'Aguardando Laudo Anterior',
        'aguardando_exame_complementar': 'Aguardando Exame Complementar',
        'aguardando_avaliacao_medica': 'Aguardando Avaliação Médica',
        'outro_pendencia': 'Outro',
        // Motivos de Reconvocação
        'complemento_exame': 'Complemento de Exame',
        'exame_inconclusivo': 'Exame Inconclusivo',
        'nova_avaliacao': 'Nova Avaliação',
        'controle': 'Controle',
        'repeticao_exame': 'Repetição de Exame',
        'exame_insatisfatorio': 'Exame Insatisfatório',
        'outro_reconvocacao': 'Outro'
      }
      return reasonMap[reasonType] || reasonType
    }

    // Lifecycle
    onMounted(() => {
      // Aplica os estilos do ClinicStore
      clinicStore.applyClinicStyles()
      loadQueue()
    })

    return {
      isLoading,
      recallQueue,
      currentPage,
      itemsPerPage,
      showScheduleModal,
      showDetailsModal,
      selectedRecallItem,
      filters,
      stats,
      paginationStart,
      paginationEnd,
      totalItems,
      totalPages,
      loadQueue,
      refreshQueue,
      applyFilters,
      clearFilters,
      previousPage,
      nextPage,
      openScheduleModal,
      closeScheduleModal,
      viewDetails,
      closeDetailsModal,
      onRecallScheduled,
      cancelRecall,
      formatDate,
      formatDateTime,
      getStatusText,
      getStatusBadgeClass,
      getTypeText,
      getTypeBadgeClass,
      getReasonTypeText
    }
  }
}
</script> 